
/**
 * Get the URL of the current page but targeting a specific route handler.
 * @param handlerName The name of the C# handler method to call
 * @returns The URL of the current page but for the given handler
 * @example ```ts
 *      //Current page https://localhost:44315/reports/plasc?LocalAuthority=660&Schools=2130#top
 *      const postTarget = currentPageWithHandler('DownloadReport');
 *       //postTarget: https://localhost:44315/reports/plasc?LocalAuthority=660&Schools=2130&handler=DownloadReport
 *      await axios.post(postTarget, formData)
 * ```
 */
export const currentPageWithHandler = (handlerName: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set("handler", handlerName);
    return url.href;
}
